import { render, staticRenderFns } from "./EmailConfirmationView.vue?vue&type=template&id=65a95f32&"
import script from "./EmailConfirmationView.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports